import { useContext } from 'react';
import { TeamsContext } from '@/contexts/TeamsContext';

/**
 * Hook to access Teams context
 * @returns Teams context if available, null if not in Teams environment
 */
export const useTeams = () => {
  const context = useContext(TeamsContext);
  // Return null instead of throwing when not in Teams environment
  // This allows the hook to be called unconditionally (React Rules of Hooks)
  return context ?? null;
};
